export const GET_BOOKING_LINK_DATA =  'GET_BOOKING_LINK_DATA'
export const GET_BOOKING_LINK_DATA_SUCCESS =  'GET_BOOKING_LINK_DATA_SUCCESS'
export const GET_BOOKING_LINK_DATA_ERROR =  'GET_BOOKING_LINK_DATA_ERROR'
export const CLEAR_BOOKING_LINK_DATA =  'CLEAR_BOOKING_LINK_DATA'